import colors from "vuetify/es5/util/colors";

export default {
  primary: colors.orange,
  secondary: colors.amber,
  tertiary: colors.yellow.base
};
